import { Tenant } from "types/api"

import { CredentialProvider } from "./types"

export interface ProviderGuide {
  provider: CredentialProvider
  /** Verbatim vendor snippet, untranslated; its ALL_CAPS placeholders drive `extract`. */
  snippet: string
  /** Keys under `settings.liveChat.guide.<provider>.extract.` — where each value hides. */
  extract: string[]
  /** Keys under `settings.liveChat.guide.<provider>.requirements.` — what to arrange first. */
  requirements: string[]
}

export const PROVIDER_GUIDES: ProviderGuide[] = [
  {
    provider: "intercom",
    snippet: `<script>
  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "APP_ID"
  };
</script>
<script>/* Intercom loader — no values to copy from here */</script>`,
    extract: ["appId", "hashKey"],
    requirements: ["identityVerification", "domains", "attributes", "noPaste"]
  },
  {
    provider: "tawk",
    snippet: `<!--Start of Tawk.to Script-->
<script type="text/javascript">
var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
  var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
  s1.async=true;
  s1.src='https://embed.tawk.to/PROPERTY_ID/WIDGET_ID';
  s1.charset='UTF-8';
  s1.setAttribute('crossorigin','*');
  s0.parentNode.insertBefore(s1,s0);
})();
</script>
<!--End of Tawk.to Script-->`,
    extract: ["propertyId", "widgetId", "apiKey"],
    requirements: ["domains", "secureMode", "noPaste"]
  },
  {
    provider: "inhouse",
    snippet: `<script src="https://WIDGET_HOST/embed.js" data-key="WORKSPACE_KEY" async></script>`,
    extract: ["host", "publicKey", "hashSecret"],
    requirements: ["frameAncestors", "identity", "placement", "noPaste"]
  }
]

const toOrigin = (value: string | undefined): string => {
  if (!value) return ""
  try {
    return new URL(value).origin
  } catch {
    return ""
  }
}

/** The origins a vendor has to allowlist, read from the Tenant row. */
export function buildTenantOrigins(tenant: Tenant | null): string[] {
  const origins = [toOrigin(tenant?.prod_frontend), toOrigin(tenant?.stage_frontend)].filter(Boolean)

  return Array.from(new Set(origins))
}
